const hu = {
    nav: {
      home: "Kezdőlap",
      browse: "Esküvők böngészése",
      dashboard: "Vezérlőpult",
      messages: "Üzenetek",
      profile: "Profil",
      login: "Bejelentkezés",
      register: "Regisztráció",
      logout: "Kijelentkezés",
      admin: "Admin",
      faq: "GYIK",
      about: "Rólunk",
      contact: "Kapcsolat",
      pricing: "Árak",
      howItWorks: "Hogyan működik",
    },
    auth: {
      login: {
        title: "Üdv újra",
        email: "E-mail",
        password: "Jelszó",
        button: "Bejelentkezés",
        noAccount: "Nincs fiókod?",
        register: "Regisztrálj most",
      },
      register: {
        title: "Fiók létrehozása",
        name: "Teljes név",
        email: "E-mail",
        password: "Jelszó",
        role: "Szeretnék...",
        roleHost: "Esküvőt szervezni",
        roleGuest: "Esküvőkön részt venni",
        terms: "Elfogadom a feltételeket és az adatvédelmi szabályzatot",
        button: "Regisztráció",
        hasAccount: "Már van fiókod?",
        login: "Jelentkezz be",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "Betöltés...",
      error: "Hiba történt",
      success: "Sikeres",
      save: "Mentés",
      cancel: "Mégse",
      delete: "Törlés",
      edit: "Szerkesztés",
      back: "Vissza",
      next: "Következő",
      language: "Nyelv",
      currency: "Pénznem",
      search: "Keresés",
      filter: "Szűrés",
      all: "Összes",
      none: "Nincs",
      yes: "Igen",
      no: "Nem",
    },
    footer: {
      about: "Rólunk",
      privacy: "Adatvédelem",
      terms: "Feltételek",
      contact: "Kapcsolat",
      copyright: "© 2024 WEDVAYA. Minden jog fenntartva.",
    },
  };

export default hu;
